import { useState, useEffect } from 'react';
import HiddenUsersStorage from '../localStorage/hiddenUsersStorage';
import { SharedImage } from '../types';

/**
 * Hook for managing users posts that are hidden from the feed
 */
const useHideUsersPosts = () => {
  // Initialize the storage service
  const hiddenUsersStorage = new HiddenUsersStorage();

  // State to track hidden user IDs
  const [hiddenUserIds, setHiddenUserIds] = useState<string[]>([]);

  // Load hidden users on mount
  useEffect(() => {
    const storedIds = hiddenUsersStorage.getHiddenUserIds();
    setHiddenUserIds(storedIds);
  }, []);

  // Check if a user is hidden
  const isUserHidden = (userId?: string) => {
    if (!userId) return false;
    return hiddenUserIds.includes(userId);
  };

  // Hide a user's posts
  const hideUsersPosts = (userId: string) => {
    hiddenUsersStorage.hideUser(userId);
    setHiddenUserIds(hiddenUsersStorage.getHiddenUserIds());
  };

  // Unhide a user's posts
  const unhideUsersPosts = (userId: string) => {
    hiddenUsersStorage.unhideUser(userId);
    setHiddenUserIds(hiddenUsersStorage.getHiddenUserIds());
  };

  // Get all hidden user IDs
  const getHiddenUserIds = () => hiddenUserIds;

  const filterImagesByHiddenUsers = (images: SharedImage[]) => {
    return images.filter((image) => !isUserHidden(image.userId));
  };

  return {
    hideUsersPosts,
    unhideUsersPosts,
    isUserHidden,
    getHiddenUserIds,
    filterImagesByHiddenUsers,
  };
};

export default useHideUsersPosts;
